import { Control, UseFormSetValue } from "react-hook-form";
import { usePricingConfigurator } from "../../hooks/use-pricing-configurator";
import { ParkingRateFormValues } from "../../parking-payment.const";
import { RateTypeEnum } from "../../pricing-configurator.types";
import { AnchorInputSection } from "./anchor-input-section";

type LongDurationConfiguratorProps = {
  control: Control<ParkingRateFormValues>;
  setValue: UseFormSetValue<ParkingRateFormValues>;
};

export const LongDurationConfigurator = ({ control, setValue }: LongDurationConfiguratorProps) => {
  const { anchors, insertAnchorAfter, reorderAnchors, removeAnchor, updateAnchor, updateAnchorUnit, toggleShortcut } =
    usePricingConfigurator({ control, setValue, rateType: RateTypeEnum.LONG });

  return (
    <div className="space-y-6">
      <AnchorInputSection
        anchors={anchors}
        showUnitColumn
        onRemoveAnchor={removeAnchor}
        onUpdateAnchor={updateAnchor}
        onUpdateAnchorUnit={updateAnchorUnit}
        onInsertAnchorAfter={insertAnchorAfter}
        onReorderAnchors={reorderAnchors}
        onToggleShortcut={toggleShortcut}
      />
    </div>
  );
};
